import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from './components/common/Sonner.tsx';
import {
  SentryErrorBoundary,
  initSentry,
} from './integrations/sentry/sentry.ts';
import {
  ReactQueryProvider,
  getContext,
} from './integrations/tanstack-query/ReactQueryProvider.tsx';
import { TanStackDevtoolsProvider } from './integrations/tanstack-query/TanStackDevtoolsProvider.tsx';
import { BreakpointProvider } from './lib/contexts/BreakpointContext.tsx';
import { routeTree } from './routes/Router.tsx';
import './styles/styles.css';

initSentry();

const queryContext = getContext();
const router = createRouter({
  routeTree,
  context: {
    ...queryContext,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <SentryErrorBoundary showDialog={false}>
        <ReactQueryProvider queryClient={queryContext.queryClient}>
          <BreakpointProvider>
            <RouterProvider router={router} />

            <Toaster />

            <TanStackDevtoolsProvider router={router} />
          </BreakpointProvider>
        </ReactQueryProvider>
      </SentryErrorBoundary>
    </StrictMode>,
  );
}
